<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.value"
      :key="option.value"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterTemperatures",
  props: {
    label: {
      type: String,
      default: "Temperature"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].temperatures;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "temperatures",
          value
        ]);
      }
    },
    options() {
      return [
        { value: null, label: 'All temps' },
        ...this.$store.state.enums.temperatureEnum
      ];
    },
    text() {
      if (this.filterValue) {
        let temperature = this.$store.state.enums.temperatureEnum.find(temperature => temperature.value === this.filterValue);
        return "Only " + temperature.label + " Leads";
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
